import { logEvent } from 'firebase/analytics';
import { analytics } from '../firebase';

// Lightweight, best-effort event tracking. Analytics may be unavailable
// (SSR, blocked, first paint before init) — never let a tracking call throw
// or block the UI. Events land in the existing GA4 property; a later
// BigQuery export (console) makes them queryable for research.
export function track(event, params = {}) {
  try {
    if (analytics) logEvent(analytics, event, params);
  } catch (_) {
    /* analytics is non-critical; swallow */
  }
}
